import { createApiAction } from '@saucelabs/sl-util-redux';

import types from './types';
import api from './api';

const updateTestConfigValue = (payload) => ({
  type: types.UPDATE_TEST_CONFIG_VALUE,
  payload,
});

const applyRecentConfiguration = (configurations) => ({
  type: types.APPLY_RECENT_CONFIGURATAION,
  payload: configurations,
});

const fetchBrowserOptions = createApiAction(
  types.BROWSER_OPTIONS_FETCH,
  () => api.fetchBrowserOptions(),
  { meta: { skipErrorPage: true } },
);

const fetchVirtualDeviceOptions = createApiAction(
  types.VIRTUAL_DEVICE_OPTIONS_FETCH,
  () => api.fetchVirtualDeviceOptions(),
  { meta: { skipErrorPage: true } },
);

export default {
  applyRecentConfiguration,
  fetchBrowserOptions,
  fetchVirtualDeviceOptions,
  updateTestConfigValue,
};
